import type { ReviewPrinting } from "./catalogue";

/** Catalogue images only: a printing choice must never reuse the user's capture. */
export function printingImageSource(
  printing: ReviewPrinting,
  size: "small" | "normal" = "small",
): string | null {
  if (size === "small" && printing.image) return printing.image;
  if (size === "normal") {
    if (printing.imageNormal) return printing.imageNormal;
    if (printing.image) {
      try {
        const url = new URL(printing.image);
        if (url.origin === "https://cards.scryfall.io" && url.pathname.startsWith("/small/")) {
          url.pathname = url.pathname.replace(/^\/small\//, "/normal/");
          return url.href;
        }
      } catch {
        // A missing or non-absolute API URL can still use the printing ID below.
      }
    }
  }
  const id = printing.scryfall;
  if (id?.length >= 2) {
    const face = printing.face ? "back" : "front";
    return `https://cards.scryfall.io/${size}/${face}/${id[0]}/${id[1]}/${id}.jpg`;
  }
  return printing.image || null;
}
